import React from "react";
import { CATEGORY_LABELS } from "@/components/sections/FaqItem";

// Search box with clear button.
export const FaqSearch = ({ query, onChange, onClear, inputRef }) => (
  <div className="cfl-search-shell">
    <label className="cfl-visually-hidden" htmlFor="cfl-faq-search">Search frequently asked questions</label>
    <svg className="cfl-search-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="m16 16 5 5" />
    </svg>
    <input
      ref={inputRef}
      className="cfl-search"
      id="cfl-faq-search"
      type="search"
      placeholder="Search questions, e.g. venue or CPF payouts"
      autoComplete="off"
      data-testid="faq-search-input"
      value={query}
      onChange={(e) => onChange(e.target.value)}
    />
    <button className="cfl-search-clear" type="button" aria-label="Clear FAQ search" hidden={query.length === 0} onClick={onClear}>
      ×
    </button>
  </div>
);

// Category filter chips + live result count.
export const FaqFilters = ({ categories, active, onSelect, visibleCount }) => (
  <div className="cfl-filter-row" role="group" aria-label="Filter frequently asked questions">
    {categories.map((cat) => (
      <button
        key={cat}
        className="cfl-filter"
        type="button"
        aria-pressed={active === cat}
        data-category={cat}
        data-testid={`faq-filter-${cat}`}
        onClick={() => onSelect(cat)}
      >
        {CATEGORY_LABELS[cat] || cat}
      </button>
    ))}
    <span className="cfl-result-count" aria-live="polite">
      Showing {visibleCount} {visibleCount === 1 ? "answer" : "answers"}
    </span>
  </div>
);

export const FaqNoResults = ({ onReset }) => (
  <div className="cfl-no-results" data-testid="faq-no-results">
    <span>?</span>
    <strong>No matching answer found</strong>
    <small>Try another phrase or view all questions.</small>
    <button type="button" onClick={onReset}>Clear search and filters</button>
  </div>
);

export const FaqIntro = ({ visible, total }) => (
  <header className={`cfl-intro${visible ? " is-visible" : ""}`}>
    <p className="cfl-eyebrow">Good to know</p>
    <h2 id="cpf-faq-title">Questions before you reserve?</h2>
    <p className="cfl-intro__copy">
      Everything you need to know before attending the seminar. Search a phrase or choose a category to find your answer quickly.
    </p>
    <div className="cfl-answer-status">
      <span className="cfl-answer-status__icon">?</span>
      <span className="cfl-answer-status__copy">
        <strong>{total} quick answers</strong>
        <small>Event details, CPF milestones and registration</small>
      </span>
    </div>
    <a className="cfl-contact" href="mailto:marketing@affinitygroup.sg?subject=CPF%20Seminar%20Question" data-testid="faq-contact-link">
      Still need help? Contact us <span aria-hidden="true">→</span>
    </a>
  </header>
);

export const FaqBackground = () => (
  <div className="cfl-background" aria-hidden="true">
    <span className="cfl-question-mark cfl-question-mark--one">?</span>
    <span className="cfl-question-mark cfl-question-mark--two">?</span>
    <span className="cfl-question-mark cfl-question-mark--three">?</span>
    <span className="cfl-ring" />
    <svg className="cfl-wave" viewBox="0 0 1440 900" preserveAspectRatio="none">
      <path d="M-60 690 C230 520, 380 720, 640 485 S1050 220, 1500 420" />
      <path d="M-20 215 C290 385, 450 120, 745 330 S1110 735, 1470 610" />
    </svg>
  </div>
);
